// Estado da janela "QR Codes das mesas": lista, seleção e as ações em massa.
import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";

import { baixarPdfCartoes, gravarNomeQr, listarMesas } from "./api";
import { imprimirNaTermica } from "./imprimirNaTermica";

export function useQrCodesEmMassa(aberto) {
  const [mesas, setMesas] = useState([]);
  const [config, setConfig] = useState(null);
  // Começa carregando: sem isso a janela abria com "Nenhuma mesa cadastrada" e
  // "Todas (0)" por um instante, antes da 1ª leitura
  const [carregando, setCarregando] = useState(true);
  const [selecionadas, setSelecionadas] = useState(() => new Set());
  const [ocupado, setOcupado] = useState(null); // "pdf" | "imprimir" | null

  const carregar = useCallback(async (manterSelecao = false) => {
    setCarregando(!manterSelecao);
    try {
      const { data } = await listarMesas();
      const lista = data?.mesas || [];
      setMesas(lista);
      setConfig(data?.config || null);
      if (!manterSelecao) setSelecionadas(new Set(lista.map((m) => m.id)));
    } catch {
      toast.error("Não consegui carregar as mesas.");
    } finally {
      setCarregando(false);
    }
  }, []);

  useEffect(() => { if (aberto) carregar(); }, [aberto, carregar]);

  const todas = mesas.length > 0 && selecionadas.size === mesas.length;
  // Todas marcadas vai como lista vazia: o servidor entende "todas as mesas".
  const idsEscolhidos = () => (todas ? [] : mesas.filter((m) => selecionadas.has(m.id)).map((m) => m.id));

  const alternar = (id) => setSelecionadas((atual) => {
    const nova = new Set(atual);
    if (nova.has(id)) nova.delete(id); else nova.add(id);
    return nova;
  });
  const alternarTodas = () => setSelecionadas(todas ? new Set() : new Set(mesas.map((m) => m.id)));

  const baixarPdf = async () => {
    setOcupado("pdf");
    try {
      await baixarPdfCartoes(idsEscolhidos());
    } catch {
      toast.error("Não consegui gerar o PDF.");
    } finally {
      setOcupado(null);
    }
  };

  const imprimir = async () => {
    const n = selecionadas.size;
    if (n > 3 && !window.confirm(`Imprimir ${n} cartões na impressora do caixa?`)) return;
    setOcupado("imprimir");
    try {
      await imprimirNaTermica(idsEscolhidos());
    } finally {
      setOcupado(null);
    }
  };

  const atualizarNomeQr = async (mesa) => {
    try {
      await gravarNomeQr(mesa.id, mesa.nome);
      toast.success(`O QR agora mostra "${mesa.nome}". Imprima o cartão novo.`);
      carregar(true);
    } catch {
      toast.error("Não consegui atualizar o nome do QR Code.");
    }
  };

  return {
    mesas, config, carregando, selecionadas, todas, ocupado,
    alternar, alternarTodas, baixarPdf, imprimir, atualizarNomeQr,
  };
}
